module.exports = __webpack_public_path__ + "static/media/icon-help-chat.da0d272f.svg";